/**
 * Brand system for AGRAGA Velora.
 *
 * The emblem is shown WITH its original crest background, framed as a luxury
 * seal/plaque. "AGRAGA" and "VELORA" always share identical weight, size and
 * colour to express the equal bond between Sanskrit India and Latin Rome.
 */

const LOGO_SRC = "/agraga-logo-full.jpg";

export function Logo({ className = "", rounded = "rounded-2xl", glow = false }) {
  return (
    <span
      className={`inline-block overflow-hidden ${rounded} ring-1 ring-[#B08D57]/35 ${className}`}
      style={
        glow
          ? { boxShadow: "0 10px 40px rgba(176,141,87,0.28), inset 0 0 0 1px rgba(255,255,255,0.06)" }
          : { boxShadow: "0 4px 18px rgba(17,17,17,0.10)" }
      }
    >
      <img src={LOGO_SRC} alt="AGRAGA Velora emblem" className="w-full h-full object-cover" />
    </span>
  );
}

export function Wordmark({
  color = "#111",
  className = "",
  size = "text-sm md:text-[15px]",
  spacing = "0.22em",
}) {
  return (
    <span
      className={`font-display ${size} ${className}`}
      style={{ color, letterSpacing: spacing, fontWeight: 500, whiteSpace: "nowrap" }}
    >
      AGRAGA VELORA
    </span>
  );
}

/** Inline lockup: framed emblem + wordmark (navigation bar). */
export function BrandInline({ color = "#111", emblem = "w-11 h-11", glow = false, className = "" }) {
  return (
    <span className={`flex items-center gap-3 ${className}`}>
      <Logo className={emblem} rounded="rounded-xl" glow={glow} />
      <Wordmark color={color} />
    </span>
  );
}

/** Stacked lockup: framed emblem over wordmark over a hairline tagline. */
export function BrandStacked({
  color = "#F8F7F3",
  tagColor = "#B08D57",
  emblem = "w-20 h-20",
  glow = true,
  tagline = "Trust. Delivered.",
  align = "center",
  className = "",
}) {
  const alignCls = align === "start" ? "items-start text-left" : "items-center text-center";
  return (
    <div className={`flex flex-col ${alignCls} ${className}`}>
      <Logo className={emblem} rounded="rounded-2xl" glow={glow} />
      <div className="mt-6 flex items-center gap-3">
        <span className="h-px w-6" style={{ background: tagColor, opacity: 0.6 }} />
        <Wordmark color={color} spacing="0.3em" size="text-sm" />
        <span className="h-px w-6" style={{ background: tagColor, opacity: 0.6 }} />
      </div>
      {tagline && (
        <p
          className="font-display italic mt-3 text-lg"
          style={{ color: tagColor, letterSpacing: "0.04em" }}
        >
          {tagline}
        </p>
      )}
    </div>
  );
}
